import React from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { strip } from '../../common/utils';
import { searchActions } from '../../../store/searchStore';
import { hasPermission } from '../../../store/apiWrapper';
import { popupActions } from "../../../store/popupStore";
import { AddToClipboardButton } from '../../common/refButtons';
import { isNullOrUndefined, openInNewWindow } from '../../../store/storeFunctions';
import ReportButtons from "../../../components/search/reportButtons";
import FoIcon from '../../../img/icons/FyzickaOsoba';
import FpoIcon from '../../../img/icons/FyzickaOsobaPodnikatel';
import PoIcon from '../../../img/icons/PravnickaOsoba';
import PortfolioIcon from '../../../img/icons/BBiconsPridatDoPortfolia';
import AddrIcon from '../../../img/icons/Domu';
import WarningIcon from '../../../img/icons/BBiconsVi';
import BasicInfoLink from '../../common/basicInfoLink';
import ReactHtmlParser from 'react-html-parser';

class WidgetRow extends React.Component {
    state = {
        expanded: false,
        tooltipOpened: false
    };

    render() {
        const subject = this.props.subject;
        if (!subject || isNullOrUndefined(subject))
            return null;
        return (
            <div key={subject.entityId} className="widget-subject-row">
                <div className="rows" style={{width:this.props.maxTableWidth}}>
                    <div className="row-1">
                    {this.renderIcon(subject)}
                        <div className="entity-name">
                            <BasicInfoLink entityId={subject.entityId} isAddress={subject.reports.AR} title={strip(subject.name)}>
                                {ReactHtmlParser(subject.name)}
                            </BasicInfoLink>
                        </div>
                        <div className="icons">
                            {subject.reports.NI && <WarningIcon
                                style={{ cursor: 'pointer' }}
                                className='icon-centered svg-ni-fill'
                                onClick={() => openInNewWindow(`/warnings/${subject.entityId}`, this.props.translate("Report.Warnings.SectionName"))}
                                title={this.props.translate('Report.Warnings.SectionName')} />}
                                { hasPermission(null, 'MainMonitoring') &&
                                    <PortfolioIcon
                                    style={{ cursor: 'pointer' }}
                                    className='icon-centered svg-standard-fill'
                                    onClick={() => this.openPortfolioPopup(subject)}
                                    title={this.props.translate('Monitoring.Add.AddToPortfolio')} />  
                                }                          
                            <AddToClipboardButton entityId={subject.entityId} onAdd={() => this.props.addToClipboard(subject, this.props.translate('Search.Clipboard.SubjectAdded'))}
                                onRemove={() => this.props.removeFromClipboard(subject, this.props.translate('Search.Clipboard.SubjectRemoved'))} hideLabel />
                        </div>
                    </div>
                    {subject.type === 1}
                    <div className="row-2">
                        <ReportButtons entityInfo={subject} useShort maxTableWidth={this.props.maxTableWidth} visibleButtonCount={3} style={{ minWidth: '100%', maxWidth: '100%' }} />
                    </div>
                </div>

            </div>
        )
    }

    renderIcon = (entityInfo) => {
        const Icon = entityInfo.type === 1 ? (entityInfo.entrepreneur === true ? FpoIcon : PoIcon) : entityInfo.reports.AR ? AddrIcon : FoIcon;
        return (
            <div className="icon-wrap">
                <Icon className='icon-centered svg-standard-fill' />
            </div>
        );
    }

    openPortfolioPopup = (subject) => {
        this.props.showPopup("addToPortfolioPopup", {
            open: true,
            subject,
            ok: () => { },
            close: () => { this.props.hidePopup(); }
        });
    }
}

export default withRouter(withLocalize(connect(
    state => state.search,
    dispatch => bindActionCreators({ ...searchActions, ...popupActions}, dispatch),
)(WidgetRow)));